import {Params} from '../getConfig'

export const amplifyVioStaging: Params = {
  aws_user_pools_id: 'eu-west-1_LTpBgi2PL',
  aws_cognito_identity_pool_id:
    'eu-west-1:0d463836-d7ef-48ae-a557-1899bd30decc',
  aws_user_pools_web_client_id: '4kiqeq7ujg5ejuiinhi86aac9i',
  oauth_domain: 'staging.dev-authentication.vio.com',
  aws_user_files_s3_bucket: 'findhotel-profile-pictures-dev'
}
